module.exports = __webpack_public_path__ + "static/img/9.49a4623.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/9.png
// module id = SUUk
// module chunks = 0